/**
 * Extend product view validation JS of Magento Catalog module
 **/
define([
    'jquery'
],
($) => {
    return function (widget) {
        $.widget('mage.validation', widget, {
            options: {
                /**
                 * Extended errorPlacement function to hide error message container
                 * after 7s if it has content
                 *
                 * @param {*} error
                 * @param {HTMLElement} element
                 *
                 * @override
                 */
                errorPlacement: function (error, element) {
                    var messageBox,
                        dataValidate;

                    if ($(element).hasClass('datetime-picker')) {
                        element = $(element).parent();

                        if (element.parent().find('[generated=true].mage-error').length) {
                            return;
                        }
                    }

                    if (element.attr('data-errors-message-box')) {
                        messageBox = $(element.attr('data-errors-message-box'));
                        messageBox.html(error);
                        clearTimeout(window.messageTimeout);

                        window.messageTimeout = setTimeout(() => {
                            const mageErrorMessage = messageBox.find('.mage-error');
                            if (mageErrorMessage) {
                                mageErrorMessage.hide('blind', () => mageErrorMessage.remove(), 500);
                            }
                        }, 7000);

                        return;
                    }

                    dataValidate = element.attr('data-validate');

                    if (dataValidate && dataValidate.indexOf('validate-one-checkbox-required-by-name') > 0) {
                        error.appendTo('#links-advice-container');
                    } else if (element.is(':radio, :checkbox')) {
                        element.closest(this.radioCheckboxClosest).after(error);
                    } else {
                        element.after(error);
                    }
                }
            }
        });

        return $.mage.validation;
    };
});
